import { ProcessConfigFactory, ProcessConfigGroup, ProcessConfigPersonnelType } from '@/Domain/Entities';
import { ProcessConfigurationTypes } from '@/Domain/enum';
import MasterDataService from '@/Services/MasterDataService';

export const ProcessConfigStore = {
    namespaced: true,
    state: {
        processConfigGroups: [],
        processConfigPersonnelTypes: []
    },
    mutations: {
        setProcessConfigGroups(state, processConfigGroups: ProcessConfigGroup[]) {
            state.processConfigGroups = processConfigGroups;
        },
        setProcessConfigPersonnelTypes(state, processConfigPersonnelTypes: ProcessConfigPersonnelType[]) {
            state.processConfigPersonnelTypes = processConfigPersonnelTypes;
        }
    },
    actions: {
        async loadProcessConfigGroups({ commit }) {
            const response = await MasterDataService.getProcessConfigGroupsCatalog();
            commit('setProcessConfigGroups', response.map(processConfig => ProcessConfigFactory.create(ProcessConfigurationTypes.enum.GROUPSUBGROUP, processConfig)));
        },
        // Catálogo completo (incluidos los ocultos): los procesos existentes resuelven su tipo contra él.
        async loadProcessConfigPersonnelTypes({ commit }) {
            const response = await MasterDataService.getProcessConfigPersonnelTypesCatalog();
            commit('setProcessConfigPersonnelTypes', response.map(processConfig => ProcessConfigFactory.create(ProcessConfigurationTypes.enum.PERSONNELTYPE, processConfig)));
        }
    },
    getters: {
        getProcessConfigGroups(state) {
            return state.processConfigGroups;
        },
        getProcessConfigPersonnelTypes(state) {
            return state.processConfigPersonnelTypes;
        }
    }
};
